import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgWarning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5 8.25a.5.5 0 0 0-1 0h1Zm-1 .25a.5.5 0 0 0 1 0h-1Zm0-4v3h1v-3h-1Zm0 3.75v.25h1v-.25h-1Z"
      fill="#17181A"
    />
    <path
      d="M5.562 2.334a.5.5 0 0 1 .876 0l3.809 6.925a.5.5 0 0 1-.438.741H2.19a.5.5 0 0 1-.438-.741l3.809-6.925Z"
      stroke="#17181A"
    />
  </svg>
);
const Memo = memo(SvgWarning);
export default Memo;
